/**
 * Free-form activities (F3.3, SELF-ONLY — no client variant) and the
 * effectiveness overview for self (F3.4). Activity scalars are exploded
 * into the spine on the BE (activity_duration_min / activity_kcal /
 * activity_distance).
 */
import type { ApiCreateActivityLogDto } from '@mfw/common';

import type {
  FetchEffectivenessArgs,
  FetchActivityLogArgs,
  ApiActivityLogEntry,
} from './types/statsEntries.types';
import type { ApiEffectiveness } from './types/stats.types';

import { destroy, post, get } from './axios';

export const createActivityLog = async (dto: ApiCreateActivityLogDto) => {
  const response = await post<ApiActivityLogEntry>(
    '/v2/stats/activity-log',
    dto,
  );
  // BE returns the raw entity, but the `post` helper types a `{data}` wrapper
  return (response ?? null) as ApiActivityLogEntry | null;
};

export const fetchActivityLog = async (args: FetchActivityLogArgs = {}) => {
  const response = await get<ApiActivityLogEntry[]>('/v2/stats/activity-log', {
    query: { from: args.from, to: args.to },
  });
  return response ?? null;
};

// deletes the row AND its explosion into the spine
export const deleteActivityLog = async ({ id }: { id: string }) => {
  await destroy(`/v2/stats/activity-log/${id}`);
};

// without from/to the BE takes the last 30 days
export const fetchEffectiveness = async (args: FetchEffectivenessArgs = {}) => {
  const response = await get<ApiEffectiveness>('/v2/stats/effectiveness', {
    query: { from: args.from, to: args.to },
  });
  return response ?? null;
};
